const { BaseClient, setupClient } = require('./base-client')

const { mailmanUrl } = require('sci/utils')

class Client extends BaseClient {
    url (path) {
        return mailmanUrl(path)
    }
}

module.exports = setupClient(Client)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/mailman-client.js